import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/velkomin")({
  component: TeaserPage,
});

const ROOMS = [
  { glyph: "◉", name: "Mælaborð", tag: "Rauntímarekstur", color: "#16A75C" },
  {
    glyph: "kr",
    name: "Reiknivél",
    tag: "Sala & ávinningur",
    color: "#1E7BFF",
  },
  { glyph: "⬡", name: "Heimasíða", tag: "Markaðssamskipti", color: "#0EA5B7" },
  { glyph: "⇄", name: "CRM", tag: "Sölupípa & samningar", color: "#F0871E" },
  { glyph: "∿", name: "Spálíkan", tag: "Greining & spár", color: "#7A5AF0" },
];

function TeaserPage() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#0B1120] text-white">
      {/* Ambient glow */}
      <div className="pointer-events-none absolute -left-40 -top-40 h-[520px] w-[520px] rounded-full bg-brand/25 blur-[140px]" />
      <div className="pointer-events-none absolute -bottom-40 -right-24 h-[460px] w-[460px] rounded-full bg-[#16A75C]/20 blur-[140px]" />

      <div className="relative mx-auto flex min-h-screen max-w-[1100px] flex-col items-center justify-center px-6 py-20 text-center">
        <img
          src="/logo/atomika-horizontal-1024px.png"
          alt="Atomika"
          className="mb-10 h-10 w-auto opacity-95"
        />

        {/* Lock badge */}
        <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] shadow-[0_0_60px_rgba(30,123,255,.35)]">
          <svg
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#8FB6FF"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="4" y="11" width="16" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            <circle cx="12" cy="16" r="1.4" fill="#8FB6FF" stroke="none" />
          </svg>
        </div>

        <h1 className="max-w-3xl text-4xl font-bold leading-[1.1] sm:text-5xl md:text-6xl">
          Ný þjónusta sem{" "}
          <span className="bg-gradient-to-r from-[#8FB6FF] via-white to-[#7CE0AD] bg-clip-text text-transparent">
            breytir leiknum
          </span>
        </h1>

        <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/60">
          Rauntímavöktun, sölupípa, reiknivél og spálíkön — allt á einum stað.
        </p>

        <button
          onClick={() => navigate({ to: "/login" })}
          className="group mt-10 inline-flex items-center gap-2 rounded-xl bg-brand px-7 py-3.5 text-base font-semibold text-white shadow-[0_10px_40px_rgba(30,123,255,.45)] transition hover:bg-brand-dark"
        >
          Opna með lykilorði
          <span className="transition-transform group-hover:translate-x-0.5">
            →
          </span>
        </button>

        {/* Teased rooms */}
        <div className="mt-20 grid w-full grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5">
          {ROOMS.map((r) => (
            <div
              key={r.name}
              className="rounded-2xl border border-white/10 bg-white/[0.03] p-4 text-left backdrop-blur transition hover:border-white/20"
            >
              <div
                className="mb-3 flex h-10 w-10 items-center justify-center rounded-[11px] font-display text-base font-extrabold"
                style={{ background: `${r.color}22`, color: r.color }}
              >
                {r.glyph}
              </div>
              <div className="text-sm font-bold text-white/90">{r.name}</div>
              <div className="mt-0.5 text-[11.5px] text-white/40">{r.tag}</div>
            </div>
          ))}
        </div>

        <p className="mt-16 text-[12.5px] text-white/30">
          © {new Date().getFullYear()} Laufið · Atomika
        </p>
      </div>
    </div>
  );
}
